import(/* webpackMode: "eager" */ "/app/src/app/(public)/delivery-policy/page.tsx");
